<div *ngIf="products?.length && title" class="title text_heading-6">{{ title }}</div>

<div class="products-list" [ngClass]="productListMode">
  <ng-container *ngIf="productListMode === 'grid'">
    <lp-product-card
      *ngFor="let product of products"
      [product]="product"
      [showIsFavorite]="showIsFavorite"
    ></lp-product-card>
  </ng-container>

  <ng-container *ngIf="productListMode === 'list'">
    <lp-product-list-card
      *ngFor="let product of products"
      [product]="product"
      [showIsFavorite]="showIsFavorite"
    ></lp-product-list-card>
  </ng-container>
</div>
